import React from "react";
import AddProject from "../../smart/buttonPopups/AddProject";
import { Table } from "../DataTable";

const Projects = props => {

    const renderRow = (row, renderData) =>
        <React.Fragment>
            {renderData(row.orderNumber, { key: "id" })}
            {renderData(row.name, { key: "desc", here: "/PM/project/view/" + row.ID })}
            {renderData(row.titleName, { key: "title", hidden: props.titleID != undefined })}
            {renderData(row.created, { key: "created" })}
            {renderData(row.createdBy, { key: "createdby" })}
        </React.Fragment>

    const titleContent = props.titleID == undefined ? "" : <AddProject titleID={props.titleID} />;

    return (
        <Table title="Project Orders" titleContent={titleContent} renderRow={renderRow} cols={[
            { name: "po #", sortCol: "orderNumber" },
            { name: "desc", sortCol: "name" },
            { name: "title", sortCol: "titleName", hidden: props.titleID != undefined },
            { name: "created", sortCol: "created" },
            { name: "created by", sortCol: "createdBy" }
        ]} rows={props.rows} />
    )
}

export default Projects;